import { Base } from ".";
import { bestFitForBatteries } from "../sample";

export const BestFitForBatteries = ({ building, onClose }) => {
  return (
    <Base
      headerTitle="Best Fit For Batteries"
      building={building}
      secondButton="APPROVE NEW BATTERY ASSET"
      data={bestFitForBatteries}
      onClose={onClose}
    />
  );
};
